/**
 * @hidden
 */
export var messages = Object.create({});